import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export const ConvertStatus = ({ p, ensureSaved, onChanged }) => {
  const job = p.ai_job || {};
  const resolve = async (rename) => {
    try {
      await ensureSaved();
      await api.post(`/products/${p.id}/ai/detected-title`, { rename });
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (job.kind === "convert" && job.status === "running")
    return (
      <div className="bg-[#38171E] text-[#EDE3C8] p-5" data-testid="ai-convert-progress">
        <div className="text-[10px] tracking-[0.28em] text-[#D4AF37]">THE PRESS IS CONVERTING</div>
        <div className="font-display text-2xl text-[#F3E5AB] mt-2">{job.message || "Working"} · {job.done || 0} of {job.total} parts</div>
        <div className="h-1 bg-white/10 mt-4"><div className="h-1 bg-[#D4AF37] transition-all" style={{ width: `${((job.done || 0) / (job.total || 1)) * 100}%` }} /></div>
        <p className="text-xs mt-3 text-[#EDE3C8]/70">Long manuscripts take a few minutes. It keeps going if you close this page.</p>
      </div>
    );
  if (!job.detected_title) return null;
  return (
    <div className="border border-[#B7791F]/40 bg-[#FFF8E6] p-4 text-sm" data-testid="ai-convert-title-mismatch">
      The converted document is called <b>“{job.detected_title}”</b>, which doesn't match this title. The store listing, covers and posts follow the manuscript.
      <div className="flex flex-wrap gap-3 mt-3">
        <Button size="sm" className="rounded-none" onClick={() => resolve(true)} data-testid="ai-convert-use-doc-title-btn">Rename to “{job.detected_title.slice(0, 40)}”</Button>
        <Button size="sm" variant="outline" className="rounded-none bg-transparent" onClick={() => resolve(false)} data-testid="ai-convert-dismiss-mismatch-btn">It's correct</Button>
      </div>
    </div>
  );
};
